import { editorFormulaChange } from './../updaters';
import {
  TEMPLATE_EDITOR_INIT,
  TEMPLATE_GENERATE_GUIDS_SUCCESS,
  TEMPLATE_GET_DATASOURCES_GET_REQUEST,
  TEMPLATE_GET_DATASOURCES_GET_SUCCESS,
  TEMPLATE_GET_DATASOURCES_GET_FAILURE,
  TEMPLATE_FORMULA_CHANGE,
  TEMPLATE_FORMULA_FOCUS,
  TEMPLATE_FORMULA_BLUR
} from '../actions';
import { TemplateEditorAction, EditorState } from '../templateeditor-types';
import { produce } from 'immer';
import { mergeDeep } from '../../helpers/utility';

const initialState: EditorState = {
  sasLoaded: false
};

export default function templateeditor(existingState = initialState, action: TemplateEditorAction) {
  if (!action) {
    return existingState;
  }

  const { type, payload } = action;

  return produce(existingState, (state: EditorState) => {
    switch (type) {
      case TEMPLATE_EDITOR_INIT:
        return mergeDeep(initialState, payload);

      case TEMPLATE_GENERATE_GUIDS_SUCCESS:
      case TEMPLATE_GET_DATASOURCES_GET_REQUEST:
      case TEMPLATE_GET_DATASOURCES_GET_SUCCESS:
      case TEMPLATE_GET_DATASOURCES_GET_FAILURE:
        return { ...state, ...payload };

      case TEMPLATE_FORMULA_CHANGE:
        return editorFormulaChange(state, payload.value);

      case TEMPLATE_FORMULA_FOCUS:
        state.formulaEditor.value = payload.value;
        state.formulaEditor.tableValue = payload.tableValue;
        state.formulaEditor.row = payload.row;

        return state;

      case TEMPLATE_FORMULA_BLUR:
        return (state.formulaEditor.value = null);

      default:
        return state;
    }
  });
}
